/* OnlyCurve — CRO Edition · core scripts (no dependencies) */
(function () {
  'use strict';
  var OC = (window.OC = window.OC || {});
  var S = OC.settings || {};
  var T = OC.strings || {};

  /* ---------- utils ---------- */
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };
  OC.qs = qs; OC.qsa = qsa; OC.debounce = debounce;

  OC.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || OC.moneyFormat || '{{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, th, dec) {
      th = th === undefined ? ',' : th; dec = dec === undefined ? '.' : dec;
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    var m = format.match(rx); var key = m ? m[1] : 'amount'; var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(rx, v);
  };

  OC.toast = function (msg) {
    var el = qs('#OCToast');
    if (!el) { el = document.createElement('div'); el.id = 'OCToast'; el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  };

  /* ---------- offer clock ---------- */
  var offer = OC.offer || {};
  function offerState() {
    var now = Date.now();
    if (offer.force) return 'live';
    if (!offer.enabled) return 'post';
    if (offer.start && now < offer.start) return 'pre';
    if (offer.end && now >= offer.end) return 'post';
    return 'live';
  }
  function fmtLeft(ms) {
    var m = Math.max(0, Math.floor(ms / 60000));
    var d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mi = m % 60;
    if (d > 0) return d + (T.daysShort || 'j') + ' ' + h + 'h';
    return h + 'h ' + (mi < 10 ? '0' : '') + mi + 'min';
  }
  function tickOffer() {
    var st = offerState(), html = document.documentElement;
    html.classList.toggle('oc-offer-pre', st === 'pre');
    html.classList.toggle('oc-offer-post', st === 'post');
    qsa('[data-countdown]').forEach(function (el) {
      if (st === 'live' && offer.end) { el.textContent = fmtLeft(offer.end - Date.now()); el.closest('[data-countdown-wrap]') && el.closest('[data-countdown-wrap]').removeAttribute('hidden'); }
      else { var w = el.closest('[data-countdown-wrap]'); if (w) w.setAttribute('hidden', ''); }
    });
    return st;
  }
  OC.offerState = offerState;

  /* ---------- drawers ---------- */
  var overlay, lastFocus, openDrawer = null;
  function getOverlay() {
    if (!overlay) { overlay = document.createElement('div'); overlay.className = 'overlay'; overlay.addEventListener('click', function () { OC.closeDrawer(); }); document.body.appendChild(overlay); }
    return overlay;
  }
  OC.openDrawer = function (id, trigger) {
    var d = typeof id === 'string' ? document.getElementById(id) : id;
    if (!d) return;
    // Drawers rendered inside a sticky section (e.g. the header menu) are moved to <body>
    // so they sit above the page overlay instead of inside the section's stacking context.
    if (d.hasAttribute('data-portal') && d.parentElement !== document.body) {
      qsa('body > [data-portal]').forEach(function (old) { if (old.id === d.id && old !== d) old.remove(); });
      document.body.appendChild(d);
      void d.offsetWidth;
    }
    if (openDrawer && openDrawer !== d) OC.closeDrawer(true);
    lastFocus = trigger || document.activeElement;
    getOverlay().classList.add('is-open');
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    openDrawer = d;
    var tab = trigger && trigger.getAttribute && trigger.getAttribute('data-size-tab');
    if (tab) { var tb = d.querySelector('[data-tab="' + tab + '"]'); if (tb && !tb.hidden) tb.click(); }
    setTimeout(function () { var f = qs('[data-autofocus]', d) || qs('button, [href], input, select, textarea', d); if (f) f.focus({ preventScroll: true }); }, 60);
    d.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
  };
  OC.closeDrawer = function (silent) {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open'); openDrawer.setAttribute('aria-hidden', 'true');
    var d = openDrawer; openDrawer = null;
    if (!silent) { getOverlay().classList.remove('is-open'); document.body.classList.remove('is-locked'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
    d.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    qsa('video', d).forEach(function (v) { v.pause(); });
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (openDrawer) OC.closeDrawer(); var sp = qs('.search-panel.is-open'); if (sp) OC.closeSearch(); }
    if (e.key === 'Tab' && openDrawer) {
      var f = qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', openDrawer).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); OC.openDrawer(o.getAttribute('data-open-drawer'), o); return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); OC.closeDrawer(); }
  });

  /* ---------- header ---------- */
  function initHeader() {
    var wrap = qs('.header-wrapper');
    if (!wrap) return;
    var setH = function () { document.documentElement.style.setProperty('--header-h', wrap.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', debounce(setH, 150));
    var onScroll = function () { wrap.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- announcement ---------- */
  function initAnnouncement() {
    qsa('[data-announcement]').forEach(function (bar) {
      if (bar._ready) return; bar._ready = true;
      var all = qsa('.announcement__slide', bar);
      var slides = all.filter(function (s) { return !(s.classList.contains('oc-offer') && offerState() !== 'live'); });
      all.forEach(function (s) { s.classList.remove('is-active'); });
      if (slides[0]) slides[0].classList.add('is-active');
      qsa('.announcement__nav', bar).forEach(function (b) { b.hidden = slides.length < 2; });
      if (slides.length < 2) return;
      var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000, timer;
      var show = function (n) { slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); };
      var play = function () { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, speed); };
      var p = qs('.announcement__nav--prev', bar), n = qs('.announcement__nav--next', bar);
      p && p.addEventListener('click', function () { show(i - 1); play(); });
      n && n.addEventListener('click', function () { show(i + 1); play(); });
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', play);
      play();
    });
  }

  /* ---------- tabs ---------- */
  function initTabs(root) {
    qsa('[data-tabs]', root).forEach(function (tabs) {
      if (tabs._ready) return; tabs._ready = true;
      var btns = qsa('[data-tab]', tabs);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-selected', 'true');
          qsa('[data-tab-panel]', tabs).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === b.getAttribute('data-tab')); });
        });
      });
    });
  }
  OC.initTabs = initTabs;

  /* ---------- scroller progress ---------- */
  function initScrollers(root) {
    qsa('[data-scroller]', root).forEach(function (sc) {
      if (sc._ready) return; sc._ready = true;
      var bar = sc.parentElement && qs('.scroller-progress span', sc.parentElement);
      if (!bar) return;
      var upd = function () {
        var max = sc.scrollWidth - sc.clientWidth; if (max <= 0) { bar.parentElement.hidden = true; return; }
        bar.parentElement.hidden = false;
        var ratio = sc.clientWidth / sc.scrollWidth; bar.style.width = Math.max(ratio * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (sc.scrollLeft / max) * ((1 / Math.max(ratio, .12)) - 1) * 100 + '%)';
      };
      sc.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', debounce(upd, 150)); upd();
    });
  }
  OC.initScrollers = initScrollers;

  /* ---------- lazy autoplay videos ---------- */
  function initVideos(root) {
    var vids = qsa('video[data-autoplay], [data-autoplay-wrap] video', root);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (v.dataset.src && !v.src) { v.src = v.dataset.src; } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: .35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- before / after ---------- */
  function initBeforeAfter(root) {
    qsa('[data-ba]', root).forEach(function (ba) {
      var input = qs('input', ba); if (!input || input._ready) return; input._ready = true;
      var set = function () { ba.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', set); set();
    });
  }

  /* ---------- tracking (Meta / Klaviyo / dataLayer) ---------- */
  function track(items) {
    try {
      if (!items || !items.length) return;
      var ids = [], contents = [], value = 0, names = [];
      items.forEach(function (it) {
        var q = it.quantity || 1, p = (it.final_price || it.price || 0) / 100;
        ids.push(String(it.id)); contents.push({ id: String(it.id), quantity: q, item_price: p }); value += p * q; names.push(it.product_title || it.title || '');
      });
      value = Number(value.toFixed(2));
      var eventId = 'oc_atc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: ids, content_type: 'product', contents: contents, content_name: names[0], value: value, currency: OC.currency }, { eventID: eventId });
      var kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') kl.push(['track', 'Added to Cart', { $value: value, Currency: OC.currency, ItemNames: names, VariantIDs: ids, Quantity: contents.reduce(function (n, c) { return n + c.quantity; }, 0) }]);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'add_to_cart', event_id: eventId, currency: OC.currency, value: value, items: contents });
    } catch (e) { /* never block the cart */ }
    document.dispatchEvent(new CustomEvent('oc:added-to-cart', { detail: { items: items } }));
  }

  /* ---------- cart ---------- */
  var cart = (OC.cart = {});
  var cartSections = function () {
    var s = ['cart-drawer'];
    if (document.body.classList.contains('template-cart')) s.push('main-cart');
    return s;
  };
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var err = new Error(j.description || j.message || T.cartError); err.data = j; throw err; } return j; }); });
  }
  cart.render = function (sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = qs('[data-cart-drawer-inner]', doc), cur = qs('[data-cart-drawer-inner]');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; initScrollers(cur); }
      var cnt = qs('[data-cart-count-value]', doc);
      if (cnt) cart.setCount(parseInt(cnt.getAttribute('data-cart-count-value'), 10) || 0);
    }
    if (sections['main-cart']) {
      var d2 = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
      var f2 = qs('[data-main-cart]', d2), c2 = qs('[data-main-cart]');
      if (f2 && c2) c2.innerHTML = f2.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('oc:cart-updated'));
  };
  cart.setCount = function (n) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('data-count', n); });
  };
  cart.add = function (items, opts) {
    opts = opts || {};
    return postJSON(OC.routes.cart_add_url + '.js', { items: items, sections: cartSections().join(','), sections_url: window.location.pathname })
      .then(function (res) {
        track(res.items || [res]);
        if (opts.buyNow) { window.location.href = OC.routes.checkout_url || '/checkout'; return res; }
        cart.render(res.sections);
        if (S.cartType === 'page' && !document.body.classList.contains('template-cart')) { window.location.href = OC.routes.cart_url; return res; }
        if (opts.open !== false && S.openOnAdd) OC.openDrawer('CartDrawer');
        else OC.toast(T.added);
        return res;
      });
  };
  cart.change = function (key, quantity) {
    return postJSON(OC.routes.cart_change_url + '.js', { id: key, quantity: quantity, sections: cartSections().join(','), sections_url: window.location.pathname })
      .then(function (res) { cart.render(res.sections); return res; });
  };
  cart.refresh = function () {
    return fetch(window.location.pathname + '?sections=' + cartSections().join(','))
      .then(function (r) { return r.json(); }).then(function (s) { cart.render(s); });
  };
  cart.updateNote = debounce(function (note) {
    postJSON(OC.routes.cart_update_url + '.js', { note: note }).catch(function () {});
  }, 500);

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      e.preventDefault();
      var line = q.closest('[data-cart-line]'); if (!line) return;
      var key = line.getAttribute('data-key'), cur = parseInt(line.getAttribute('data-qty'), 10) || 1;
      var next = q.getAttribute('data-cart-qty') === 'plus' ? cur + 1 : cur - 1;
      line.classList.add('is-updating');
      cart.change(key, Math.max(0, next)).catch(function (err) { line.classList.remove('is-updating'); OC.toast(err.message || T.cartError); });
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var l2 = rm.closest('[data-cart-line]'); if (!l2) return;
      l2.classList.add('is-updating');
      cart.change(l2.getAttribute('data-key'), 0).catch(function () { l2.classList.remove('is-updating'); });
      return;
    }
    var add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      add.classList.add('is-loading');
      cart.add([{ id: parseInt(add.getAttribute('data-add-variant'), 10), quantity: 1 }], { open: true })
        .catch(function (err) { OC.toast(err.message || T.cartError); })
        .then(function () { add.classList.remove('is-loading'); });
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); OC.quickAdd(qa.getAttribute('data-quick-add'), qa); }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-note]')) cart.updateNote(e.target.value);
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cart-line-input]');
    if (inp) { var line = inp.closest('[data-cart-line]'); line.classList.add('is-updating'); cart.change(line.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0)); }
  });

  /* Generic product forms (no product.js needed for simple adds) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-simple-add]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[type="submit"]', form), fd = new FormData(form);
    btn && btn.classList.add('is-loading');
    cart.add([{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || 1, 10) }])
      .catch(function (err) { OC.toast(err.message || T.cartError); })
      .then(function () { btn && btn.classList.remove('is-loading'); });
  });

  /* ---------- quick add ---------- */
  OC.quickAdd = function (url, trigger) {
    var drawer = document.getElementById('QuickAdd'); if (!drawer) { window.location.href = url; return; }
    var body = qs('[data-quick-add-body]', drawer);
    body.innerHTML = '<div class="center" style="min-height:240px"><span class="btn btn--outline is-loading" style="min-width:60px"></span></div>';
    OC.openDrawer(drawer, trigger);
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=quick-add').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var c = qs('[data-quick-add-content]', doc);
      body.innerHTML = c ? c.innerHTML : '';
      var needs = function () { if (OC.initProduct) { qsa('[data-product]', body).forEach(OC.initProduct); } };
      if (OC.initProduct) needs();
      else { var s = document.createElement('script'); s.src = OC.assets.productJs; s.onload = needs; document.head.appendChild(s); }
    }).catch(function () { window.location.href = url; });
  };

  /* ---------- search ---------- */
  OC.openSearch = function () {
    var p = qs('#SearchPanel'); if (!p) return;
    p.classList.add('is-open'); getOverlay().classList.add('is-open'); document.body.classList.add('is-locked');
    var i = qs('input[type="search"]', p); setTimeout(function () { i && i.focus(); }, 80);
  };
  OC.closeSearch = function () {
    var p = qs('#SearchPanel'); if (!p) return;
    p.classList.remove('is-open'); getOverlay().classList.remove('is-open'); document.body.classList.remove('is-locked');
  };
  function initSearch() {
    var p = qs('#SearchPanel'); if (!p) return;
    qsa('[data-open-search]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); OC.openSearch(); }); });
    qsa('[data-close-search]', p).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); OC.closeSearch(); }); });
    getOverlay().addEventListener('click', OC.closeSearch);
    var input = qs('input[type="search"]', p), out = qs('[data-search-results]', p), initial = out ? out.innerHTML : '';
    if (!input || !out || !S.predictiveSearch) return;
    var ctrl;
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = initial; return; }
      if (ctrl) ctrl.abort(); ctrl = 'AbortController' in window ? new AbortController() : null;
      fetch(OC.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); var c = qs('[data-predictive]', d); out.innerHTML = c ? c.innerHTML : ''; })
        .catch(function () {});
    }, 220));
  }

  /* ---------- collection: filters, sort, load more, card swatches ---------- */
  function initCollection() {
    var form = qs('[data-facets-form]');
    if (form) {
      form.addEventListener('change', debounce(function (e) {
        if (e.target.closest('[data-price-input]')) return;
        submitFacets(form);
      }, 120));
      qsa('[data-price-apply]', form).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); submitFacets(form); }); });
    }
    qsa('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page'); window.location.href = url.toString();
      });
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('href'); if (!url || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = qs('[data-product-grid]'), freshGrid = qs('[data-product-grid]', doc);
      if (grid && freshGrid) qsa('[data-grid-item]', freshGrid).forEach(function (it) { grid.appendChild(it); });
      var freshMore = qs('[data-load-more-wrap]', doc), wrap = qs('[data-load-more-wrap]');
      if (wrap) { if (freshMore) wrap.innerHTML = freshMore.innerHTML; else wrap.remove(); }
      if (window.history) window.history.replaceState({}, '', url);
    }).catch(function () { window.location.href = url; });
  });
  function submitFacets(form) {
    var fd = new FormData(form), params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = qs('[data-sort]'); if (sort && sort.value) params.set('sort_by', sort.value);
    window.location.href = window.location.pathname + '?' + params.toString();
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.card'); if (!card) return;
    qsa('[data-card-swatch]', card).forEach(function (b) { b.classList.toggle('is-active', b === sw); });
    var img = qs('.card__media img', card), src = sw.getAttribute('data-img'), srcset = sw.getAttribute('data-srcset');
    if (img && src) { img.src = src; if (srcset) img.srcset = srcset; }
    var link = qs('.card__title a', card), media = qs('.card__media', card), v = sw.getAttribute('data-variant');
    if (v) { [link, media].forEach(function (a) { if (a && a.href) { var u = new URL(a.href, window.location.origin); u.searchParams.set('variant', v); a.href = u.pathname + u.search; } }); }
  });

  /* ---------- faq search filter / "show more" ---------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-show-more]');
    if (!more) return;
    e.preventDefault();
    var scope = more.closest('[data-show-more-scope]') || document;
    qsa('[data-more-item]', scope).forEach(function (el) { el.hidden = false; });
    more.remove();
  });
  document.addEventListener('click', function (e) {
    var cat = e.target.closest('[data-faq-cat]');
    if (!cat) return;
    var scope = cat.closest('[data-faq]'); if (!scope) return;
    var c = cat.getAttribute('data-faq-cat');
    qsa('[data-faq-cat]', scope).forEach(function (b) { b.setAttribute('aria-selected', b === cat ? 'true' : 'false'); });
    qsa('[data-faq-item]', scope).forEach(function (it) { it.hidden = !(c === 'all' || it.getAttribute('data-faq-item') === c); });
    var sm = qs('[data-show-more]', scope); if (sm) sm.remove();
  });

  /* ---------- init ---------- */
  function init() {
    document.documentElement.classList.remove('no-js');
    tickOffer(); setInterval(tickOffer, 30000);
    if (window.matchMedia('(min-width: 750px)').matches) qsa('[data-footer-acc]').forEach(function (d) { d.open = true; });
    initHeader(); initAnnouncement(); initTabs(); initScrollers(); initVideos(); initBeforeAfter(); initSearch(); initCollection();
    document.addEventListener('drawer:open', function (e) { initScrollers(e.target); initVideos(e.target); });
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { tickOffer(); initTabs(e.target); initScrollers(e.target); initVideos(e.target); initBeforeAfter(e.target); initAnnouncement(); if (OC.initProduct) qsa('[data-product]', e.target).forEach(OC.initProduct); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
